export default __webpack_public_path__ + "static/media/30.f4079c88.jpg";